<template>
	<div>
			<p style="margin-top: 30px;"><strong>{{ category.name }}</strong></p>
			<Table
							:dataSource="category.pis"
							:columns="columns"
			>

					<template
									#customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, column }"
					>
							<div style="padding: 8px">
									<Input
													ref="searchInput"
													:placeholder="`Поиск Название проекта`"
													:value="selectedKeys[0]"
													style="width: 188px; margin-bottom: 8px; display: block"
													@change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
													@pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
									/>
									<Button
													type="primary"
													size="small"
													style="width: 90px; margin-right: 8px"
													@click="handleSearch(selectedKeys, confirm, column.dataIndex)"
									>
											<template #icon><SearchOutlined /></template>
											Найти
									</Button>
									<Button size="small" style="width: 90px" @click="handleReset(); setSelectedKeys('')">
											Сброс
									</Button>
							</div>
					</template>

					<template #bodyCell="{ column,record }">

							<template v-if="column.key === 'project_name'">
									<a :href="'/project/show/'+record.project_id" target="_blank">{{ record.project_name }}</a>
							</template>
							<template v-if="column.key === 'isFavorit'">
									<span v-if="record.isFavorit"><i style="color: #F69F22" class="fas fa-star"></i></span>
							</template>
							<template v-if="column.key === 'comment'">
									<Collapse
													:bordered="false"
									>
											<template #expandIcon="{ isActive }">
													<caret-right-outlined :rotate="isActive ? 90 : 0" />
											</template>
											<CollapsePanel :key="1">
													<template #header>
															<p class="expanded_control"> <strong>Лонг-лист</strong></p>
													</template>
													<div>
															<template v-for="(criteria,index) in record.criterias" :key="index">
																	<p><em>{{ criteria.name }}</em></p>
																	<div style="margin-bottom: 15px;">
																			<EditExpertComments
																							:pi_id="record.pi_id"
																							:user_id="expert.id"
																							:criteria_id="criteria.id"
																							tour="1"
																			></EditExpertComments>
																			<!--                                                {{ getMyScoreDataByCriterion(projectinfo, expert, criteria, 1).comment|default('') }}-->
																	</div>
															</template>
													</div>
											</CollapsePanel>
											<CollapsePanel :key="2">
													<template #header>
															<p class="expanded_control"> <strong>Шорт-лист</strong></p>
													</template>
													<div>
															<template v-for="(criteria,index) in record.criterias" :key="index">
																	<p><em>{{ criteria.name }}</em></p>
																	<div style="margin-bottom: 15px;">
																			<EditExpertComments
																							:pi_id="record.pi_id"
																							:user_id="expert.id"
																							:criteria_id="criteria.id"
																							tour="2"
																			></EditExpertComments>
																			<!--                                                {{ getMyScoreDataByCriterion(projectinfo, expert, criteria, 1).comment|default('') }}-->
																	</div>
															</template>
													</div>
											</CollapsePanel>

											<CollapsePanel :key="3">
													<template #header>
															<p class="expanded_control"> <strong>Победители</strong></p>
													</template>
													<div>
															<template v-for="(criteria,index) in record.criterias" :key="index">
																	<p><em>{{ criteria.name }}</em></p>
																	<div style="margin-bottom: 15px;">
																			<EditExpertComments
																							:pi_id="record.pi_id"
																							:user_id="expert.id"
																							:criteria_id="criteria.id"
																							tour="3"
																			></EditExpertComments>
																	</div>
															</template>
													</div>
											</CollapsePanel>
									</Collapse>
							</template>
					</template>

			</Table>
	</div>
</template>

<script>
import EditExpertComments from "@/components/EditExpertComments.vue";
import {CaretRightOutlined, SearchOutlined} from "@ant-design/icons-vue";
import {Collapse, CollapsePanel, Table} from "ant-design-vue";

export default {
  name: "EditExpertTable",
	props: {
    category: {},
		expert: {}
	},
	data() {
    return {
      columns: [
        {
          title: 'НАЗВАНИЕ ПРОЕКТА', //Как будет называться колонка
          dataIndex: 'project_name', //ключ объекта из dataSource
          key: 'project_name', //Обязательное поле. Уникальный ключ для колонки
          onFilter: (value, record) => record.project_name.toString().toLowerCase().includes(value.toLowerCase()),
          customFilterDropdown: true,
        },
        {
          title: 'АВТОР', //Как будет называться колонка
          dataIndex: 'user_fio', //ключ объекта из dataSource
          key: 'user_fio', //Обязательное поле. Уникальный ключ для колонки
        },
        {
          title: 'ОЦЕНКА', //Как будет называться колонка
          dataIndex: 'project_score', //ключ объекта из dataSource
          key: 'project_score', //Обязательное поле. Уникальный ключ для колонки
        },
        {
          title: 'ФАВОРИТ', //Как будет называться колонка
          dataIndex: 'isFavorit', //ключ объекта из dataSource
          key: 'isFavorit', //Обязательное поле. Уникальный ключ для колонки
        },
        {
          title: 'КОММЕНТАРИИ', //Как будет называться колонка
          key: 'comment', //Обязательное поле. Уникальный ключ для колонки
        },

      ],
      searchText: '',
      searchedColumn: '',
      fileteredItems: []
		}
	},
  components: {SearchOutlined, Collapse, Table, CollapsePanel, CaretRightOutlined, EditExpertComments},
	methods: {
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();

      this.filteredItems = this.category.pis.filter((record) =>
        record[dataIndex].toLowerCase().includes(selectedKeys[0].toLowerCase())
      );

      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset() {
      this.searchText = '';
    }
	}
}
</script>

<style scoped>

</style>